import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { AgEditorComponent } from 'ag-grid-angular';
import { ICellEditorParams } from 'ag-grid-community';

@Component({
  selector: 'select-cell-editor',
  templateUrl: './select-cell-editor.component.html',
  styleUrls: ['./select-cell-editor.component.scss']
})
export class SelectCellEditorComponent implements AgEditorComponent, AfterViewInit {
  @ViewChild('select') select: MatSelect;

  public value: string;
  public params: ICellEditorParams;

  getValue() {
    return this.value;
  }

  agInit(params: ICellEditorParams) {
    this.params = params;
    this.value = params.data[params.colDef.field];
  }

  ngAfterViewInit() {
    window.setTimeout(() => this.select.open());
  }

  public onChange(event) {
    this.value = event.value;
    this.params.api.stopEditing();
  }
}